import { createFileRoute, redirect } from "@tanstack/react-router"

import { FirmAgreementDraftEditor } from "@/features/firms/components/firm-agreement-draft-editor"
import { FirmAgreementDraftHeader } from "@/features/firms/components/firm-agreement-draft-header"
import { FirmAgreementDraftProvider } from "@/features/firms/components/firm-agreement-draft-provider"
import { agreementTemplateQueries } from "@/queries/agreement-templates"
import { agreementQueries } from "@/queries/agreements"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/"
)({
  loader: async ({ context, params }) => {
    const agreement = await context.queryClient.ensureQueryData(
      agreementQueries.detail(params.agreementId)
    )

    if (agreement.firm.id !== params.firmId || agreement.status !== "draft") {
      throw redirect({
        to: "/$organisation/firms/$firmId/agreement",
        params: { organisation: params.organisation, firmId: params.firmId },
      })
    }

    await context.queryClient.ensureQueryData(
      agreementTemplateQueries.placeholders()
    )
  },
  staticData: { content: "edge-to-edge" },
  component: FirmAgreementDraftPage,
})

function FirmAgreementDraftPage() {
  const { agreementId, firmId } = Route.useParams()

  return (
    <FirmAgreementDraftProvider agreementId={agreementId} firmId={firmId}>
      <FirmAgreementDraftHeader />
      <FirmAgreementDraftEditor />
    </FirmAgreementDraftProvider>
  )
}
